import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58d92c2e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "error-boundary"
}
const _hoisted_2 = { class: "error-message" }
const _hoisted_3 = { class: "error-details" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_ctx.hasError)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_v_card, {
          class: "error-boundary-card",
          elevation: "4"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "error-boundary-title" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "error",
                  size: "large",
                  class: "mr-3"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("mdi-alert-circle")
                  ]),
                  _: 1
                }),
                _createTextVNode(" Something went wrong ")
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.userFriendlyMessage), 1),
                (_ctx.showDetails)
                  ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
                      key: 0,
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_expansion_panel, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_expansion_panel_title, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { class: "mr-2" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-information")
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(" Technical Details ")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_expansion_panel_text, null, {
                              default: _withCtx(() => [
                                _createElementVNode("pre", _hoisted_3, _toDisplayString(_ctx.errorDetails), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  onClick: _ctx.handleRetry,
                  color: "primary",
                  variant: "outlined",
                  loading: _ctx.retrying
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { left: "" }, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-refresh")
                      ]),
                      _: 1
                    }),
                    _createTextVNode(" Try Again ")
                  ]),
                  _: 1
                }, 8, ["onClick", "loading"]),
                _createVNode(_component_v_btn, {
                  onClick: _ctx.handleReset,
                  variant: "text"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Reset Component ")
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showDetails = !_ctx.showDetails)),
                  variant: "text",
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.showDetails ? 'Hide' : 'Show') + " Details ", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]))
    : _renderSlot(_ctx.$slots, "default", { key: 1 }, undefined, true)
}